module.exports = __webpack_public_path__ + "img/custom-item1-6.53d2d5f.png";